module.exports = __webpack_public_path__ + "static/media/books.f61057fe.png";